module.exports = __webpack_public_path__ + "static/media/corporate-placeholder.e9425c78.webp";